'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.adyenCsePayment = adyenCsePayment;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function adyenCsePayment(cardData, publicKey, t) {
  var options = {};
  var cseInstance = adyenEncrypt.createEncryption(publicKey, options);
  var data = (0, _assign2.default)({}, cardData, { generationtime: new Date().toISOString() });

  return new _promise2.default(function (accept, reject) {
    var adyenData = cseInstance.validate(cardData);

    if (adyenData.valid) {
      return accept(cseInstance.encrypt(data));
    }

    return reject(t('spree.invalid_card_details'));
  });
}


//////////////////
// WEBPACK FOOTER
// ./client/actions/adyen.js
// module id = 2416
// module chunks = 0